import { render } from "./my-account.vue?vue&type=template&id=76bfd151&scoped=true"
import script from "./my-account.vue?vue&type=script&lang=js"
export * from "./my-account.vue?vue&type=script&lang=js"

import "./my-account.vue?vue&type=style&index=0&id=76bfd151&scoped=true&lang=css"
import "./my-account.vue?vue&type=style&index=1&id=76bfd151&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76bfd151"]])

export default __exports__